// Icon mapping utility for Lucide React icons
import {
  Accessibility, // Wheelchair
  Car,
  Calendar,
  Hospital,
  Building2,
  Briefcase,
  Clock,
  Sparkles,
  Shield,
  MapPin,
  FileCheck,
  ShieldCheck,
  Lock,
  UserCheck,
  Map,
  FileText,
  Users,
  BarChart,
  Activity,
  ClipboardList,
  Stethoscope,
  Handshake,
  Footprints,
  Wind,
  Repeat,
  Droplet,
  Brain,
  Route,
  HeartPulse
} from 'lucide-react';

export const iconMap = {
  Wheelchair: Accessibility, // Map Wheelchair to Accessibility
  Accessibility,
  Car,
  Calendar,
  Hospital,
  Building2,
  Briefcase,
  Clock,
  Sparkles,
  Shield,
  MapPin,
  FileCheck,
  ShieldCheck,
  Lock,
  UserCheck,
  Map,
  FileText,
  Users,
  BarChart,
  Activity,
  ClipboardList,
  Stethoscope,
  Handshake,
  Footprints,
  Wind,
  Repeat,
  Droplet,
  Brain,
  Route,
  HeartPulse
};
